"use strict";

var _classCallCheck = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AngleUpdater = void 0;

var Utils_1 = require("../../Utils");

function updateAngle(particle, delta) {
  var _a;

  var rotate = particle.rotate;

  if (!rotate) {
    return;
  }

  var rotateOptions = particle.options.rotate;
  var rotateAnimation = rotateOptions.animation;
  var speed = ((_a = rotate.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor;
  var max = 2 * Math.PI;

  if (!rotateAnimation.enable) {
    return;
  }

  switch (rotate.status) {
    case 0:
      rotate.value += speed;

      if (rotate.value > max) {
        rotate.value -= max;
      }

      break;

    case 1:
    default:
      rotate.value -= speed;

      if (rotate.value < 0) {
        rotate.value += max;
      }

      break;
  }
}

var AngleUpdater = /*#__PURE__*/function () {
  function AngleUpdater(container) {
    _classCallCheck(this, AngleUpdater);

    this.container = container;
  }

  _createClass(AngleUpdater, [{
    key: "init",
    value: function init(particle) {
      var rotateOptions = particle.options.rotate;
      particle.rotate = {
        enable: rotateOptions.animation.enable,
        value: (0, Utils_1.getRangeValue)(rotateOptions.value) * Math.PI / 180
      };
      var rotateDirection = rotateOptions.direction;

      if (rotateDirection === "random") {
        var index = Math.floor(Math.random() * 2);
        rotateDirection = index > 0 ? "counter-clockwise" : "clockwise";
      }

      switch (rotateDirection) {
        case "counter-clockwise":
        case "counterClockwise":
          particle.rotate.status = 1;
          break;

        case "clockwise":
          particle.rotate.status = 0;
          break;
      }

      var rotateAnimation = particle.options.rotate.animation;

      if (rotateAnimation.enable) {
        particle.rotate.velocity = rotateAnimation.speed / 360 * this.container.retina.reduceFactor;

        if (!rotateAnimation.sync) {
          particle.rotate.velocity *= Math.random();
        }
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var rotate = particle.options.rotate;
      var rotateAnimation = rotate.animation;
      return !particle.destroyed && !particle.spawning && !rotate.path && rotateAnimation.enable;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateAngle(particle, delta);
    }
  }]);

  return AngleUpdater;
}();

exports.AngleUpdater = AngleUpdater;